import React from "react";
import { useSection } from "../../../../i18n/useSection";

// Side-on, full-body mannequin. The portrait card represents the camera view.
export default function StsIllustration({
  pose = "seated",
  compact = false,
  icon = false,
}) {
  const t = useSection("sts");
  const standing = pose === "standing";
  if (icon) {
    return (
      <svg
        width="39"
        height="39"
        viewBox="0 0 30 30"
        fill="none"
        role="img"
        aria-label={t.illustration_seated}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="11.5" cy="6.3" r="2.2" fill="#2E4D72" />
        <g stroke="#2E4D72" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11.5 11V17.5" strokeWidth="3.5" />
          <path d="M12 17.5H19L20 24H23" strokeWidth="2.5" />
          <path d="M12 11.5L15 15H18" strokeWidth="2" />
          <path d="M7 12V20H16M8 20V25M15 20V25" strokeWidth="1.5" />
        </g>
      </svg>
    );
  }
  return (
    <svg
      className={`sts-illustration${compact ? " compact" : ""}`}
      viewBox="0 0 220 300"
      role="img"
      aria-label={standing ? t.illustration_standing : t.illustration_seated}
    >
      {!compact && (
        <rect
          x="8"
          y="4"
          width="204"
          height="292"
          rx="24"
          fill="#f9fafc"
          stroke="#ccd1db"
          strokeWidth="3"
        />
      )}
      <path d="M42 45V249H183" stroke="#b5bdc9" strokeWidth="3" fill="none" />
      <path
        d="M55 155V212H113M62 212V249M105 212V249"
        stroke="#7d7d7d"
        strokeWidth="9"
        strokeLinecap="round"
        fill="none"
      />
      {standing ? (
        <g
          fill="#e9e9e9"
          stroke="#8f8f8f"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="125" cy="69" r="15" />
          <path d="M123 88L120 162" strokeWidth="22" />
          <path d="M122 163L127 205L126 244H148" strokeWidth="11" fill="none" />
          <path d="M116 105L130 137L137 163" strokeWidth="9" fill="none" />
        </g>
      ) : (
        <g
          fill="#e9e9e9"
          stroke="#8f8f8f"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="83" cy="112" r="15" />
          <path d="M81 132L83 196" strokeWidth="22" />
          <path d="M84 197L131 199L137 244H157" strokeWidth="11" fill="none" />
          <path d="M86 148L112 178L133 181" strokeWidth="9" fill="none" />
        </g>
      )}
      {!compact && <circle cx="110" cy="273" r="10" fill="#ee6c3a" />}
    </svg>
  );
}
